import SapaPlaza from '../images/Sa Pa - Sa Pa Plaza.jpg';
import Fansipan from '../images/Sa Pa - Fansipan.jpg';
import Lake from '../images/Sa Pa - Lake.jpg';
import SunPlaza from '../images/Sa Pa - Sun Plaza.jpg';
import Funicular from '../images/Sa Pa Funicular Train.jpg';
import OldQuarter from '../images/Hanoi - Old Quarter.jpg';

export const SliderData = [
  {
    title: 'Mac & Kyla',
    description: 'We\'re getting married',
    image: SapaPlaza,
    alt: 'Sa Pa - Sa Pa Plaza',
  },
  {
    title: 'Mac & Kyla',
    description: 'We\'re getting married',
    image: Fansipan,
    alt: 'Sa Pa - Fansipan',
  },
  {
    title: 'Sa Pa',
    description: 'Fansipan · Roof of Indochina',
    image: Lake,
    alt: 'Sa Pa - Lake',
  },
  {
    title: 'Sa Pa',
    description: 'Sun Plaza · Rice Terraces',
    image: SunPlaza,
    alt: 'Sa Pa - Sun Plaza',
  },
  {
    title: 'Sa Pa',
    description: 'Funicular Train · Into the Clouds',
    image: Funicular,
    alt: 'Sa Pa Funicular Train',
  },
  {
    title: 'Hanoi',
    description: 'Old Quarter · Where It All Began',
    image: OldQuarter,
    alt: 'Hanoi - Old Quarter',
  },
];
